import { createContext, useContext, useState, useEffect, useCallback } from "react";
import WaitlistDialog from "@/components/WaitlistDialog";
import { trackView } from "@/lib/api";

const WaitlistContext = createContext(null);

export const useWaitlist = () => useContext(WaitlistContext);

export const WaitlistProvider = ({ children }) => {
  const [open, setOpen] = useState(false);
  const [refCode, setRefCode] = useState(null);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const ref = params.get("ref");
    if (ref) setRefCode(ref.toUpperCase());
  }, []);

  const openWaitlist = useCallback(() => {
    trackView(window.location.pathname, "waitlist_open");
    setOpen(true);
  }, []);

  return (
    <WaitlistContext.Provider value={{ openWaitlist, refCode }}>
      {children}
      <WaitlistDialog open={open} onOpenChange={setOpen} refCode={refCode} />
    </WaitlistContext.Provider>
  );
};
